import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative bg-slate-950 text-slate-400 overflow-hidden">
      {/* Subtle grid overlay */}
      <div className="absolute inset-0 bg-grid-pattern bg-grid opacity-[0.03]" />

      <div className="relative max-w-6xl mx-auto px-4 pt-16 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4 group">
              <div className="w-8 h-8 bg-brand-600 rounded-lg flex items-center justify-center shadow-sm shadow-brand-600/20">
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="10" cy="9" r="4.7" fill="white"/>
                  <circle cx="10" cy="9" r="2.4" fill="#FBBF24"/>
                  <rect x="12.4" y="11.6" width="2.4" height="4.4" rx="1.1" transform="rotate(-30 13.6 13.8)" fill="white"/>
                  <rect x="3" y="16" width="18" height="2.8" rx="1.4" fill="white"/>
                </svg>
              </div>
              <span className="text-lg font-bold">
                <span className="text-white">Link</span>
                <span className="text-brand-400">Diry</span>
              </span>
            </Link>
            <p className="text-sm text-slate-500 leading-relaxed mb-4">
              Free backlink price comparison.<br />50+ marketplaces. Updated daily.
            </p>
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-brand-500/10 border border-brand-500/20 rounded-full text-xs font-medium text-brand-400">
              <span className="w-1.5 h-1.5 bg-brand-400 rounded-full" />
              Free forever
            </div>
          </div>

          {/* Tools */}
          <div>
            <h4 className="text-xs font-semibold text-slate-300 uppercase tracking-wider mb-4">Tools</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-slate-500 hover:text-brand-400 transition-colors">Price Checker</Link></li>
              <li><Link to="/bulk-checker" className="text-slate-500 hover:text-brand-400 transition-colors">Bulk Domain Checker</Link></li>
              <li><Link to="/browse" className="text-slate-500 hover:text-brand-400 transition-colors">Browse by Niche</Link></li>
              <li><Link to="/serp" className="text-slate-500 hover:text-brand-400 transition-colors">SERP Scanner</Link></li>
              <li><Link to="/marketplaces" className="text-slate-500 hover:text-brand-400 transition-colors">Marketplaces</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-xs font-semibold text-slate-300 uppercase tracking-wider mb-4">Resources</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/blog" className="text-slate-500 hover:text-brand-400 transition-colors">Blog</Link></li>
              <li><Link to="/blog/link-building-pricing" className="text-slate-500 hover:text-brand-400 transition-colors">Link Building Pricing</Link></li>
              <li><Link to="/blog/guest-post-seo" className="text-slate-500 hover:text-brand-400 transition-colors">Guest Post SEO Guide</Link></li>
              <li><Link to="/blog/how-much-do-backlinks-cost" className="text-slate-500 hover:text-brand-400 transition-colors">Backlink Cost Guide</Link></li>
              <li><Link to="/docs" className="text-slate-500 hover:text-brand-400 transition-colors">API Documentation</Link></li>
            </ul>
          </div>

          {/* Compare */}
          <div>
            <h4 className="text-xs font-semibold text-slate-300 uppercase tracking-wider mb-4">Compare</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/vs/linkbuilder" className="text-slate-500 hover:text-brand-400 transition-colors">vs LinkBuilder</Link></li>
              <li><Link to="/vs/fatgrid" className="text-slate-500 hover:text-brand-400 transition-colors">vs FatGrid</Link></li>
              <li><Link to="/vs/linkdetective" className="text-slate-500 hover:text-brand-400 transition-colors">vs LinkDetective</Link></li>
              <li><Link to="/blog/collaborator-vs-whitepress" className="text-slate-500 hover:text-brand-400 transition-colors">Collaborator vs WhitePress</Link></li>
              <li><Link to="/blog/whitepress-alternatives" className="text-slate-500 hover:text-brand-400 transition-colors">WhitePress Alternatives</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-slate-300 uppercase tracking-wider mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/why-free" className="text-slate-500 hover:text-brand-400 transition-colors">Why It's Free</Link></li>
              <li><Link to="/partners" className="text-slate-500 hover:text-brand-400 transition-colors">For Marketplaces</Link></li>
              <li><Link to="/mcp-server" className="text-slate-500 hover:text-brand-400 transition-colors">MCP Server for AI</Link></li>
              <li><Link to="/submit" className="text-slate-500 hover:text-brand-400 transition-colors">Add Your Site</Link></li>
              <li><Link to="/embed" className="text-slate-500 hover:text-brand-400 transition-colors">Embed Widget</Link></li>
              <li><a href="mailto:support@linkdiry.com" className="text-slate-500 hover:text-brand-400 transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800/80 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-600">&copy; {new Date().getFullYear()} LinkDiry. Free backlink price comparison tool.</p>
          <div className="flex gap-6 text-xs text-slate-600">
            <Link to="/privacy" className="hover:text-slate-400 transition-colors">Privacy Policy</Link>
            <a href="mailto:support@linkdiry.com" className="hover:text-slate-400 transition-colors">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
